import React from "react"

function FourCol({contentOne, contentTwo, contentThree, contentFour}) {
    return(
        <div className="row-4">
            <div className="col-4">{contentOne}</div>
            <div className="col-4">{contentTwo}</div>
            <div className="col-4">{contentThree}</div>
            <div className="col-4">{contentFour}</div>
        </div>
    );
}

export default FourCol